import React from "react";
import ReactPaginate from "react-paginate";

const CustomPagination = ({ totalPages, handlePageChange, currentPage }) => {
  // const isSmallScreen = useMediaQuery({ query: "(max-width: 576px)" });
  // const isMediumScreen = useMediaQuery({ query: "(max-width: 768px)" });

  // const pageRangeDisplayed = isSmallScreen ? 1 : isMediumScreen ? 3 : 5;
  // const marginPagesDisplayed = isSmallScreen ? 1 : 2;
  return (
    <div>
      <ReactPaginate
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
        previousLabel={"<<"}
        nextLabel={">>"}
        breakLabel={"..."}
        pageCount={totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageChange}
        forcePage={currentPage - 1}
      />
    </div>
  );
};

export default CustomPagination;
